import React from 'react'
import {useSelector} from 'react-redux'
import {SplitBookingOfferInfo} from 'components/Offer/types'
import {getOfferAccessFlowSettings} from 'modules/sapiSearch/selectors'
import {Hotel} from 'modules/sapiSearch/slice'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

import {RoomLabelsComponent as RoomLabels} from '../../Shared/RoomLabelsComponent'

interface MainProps {
  isSplitBooking?: false
  hotelId: Hotel['objectID']
  hasRoomLabels?: boolean
  offer?: SearchOffer
  splitBookingOffers?: never
}

interface SplitBookingProps {
  isSplitBooking?: true
  hotelId: Hotel['objectID']
  hasRoomLabels?: boolean
  offer?: never
  splitBookingOffers?: SplitBookingOfferInfo[]
}

export const RoomLabelsComponent: React.FC<MainProps | SplitBookingProps> = ({
  isSplitBooking = false,
  hasRoomLabels = true,
  offer,
  hotelId,
  splitBookingOffers
}) => {
  const {isSpecialUnlocked, isAppRequiredUnlocked, isAuthRequiredUnlocked} =
    useSelector(state => getOfferAccessFlowSettings(state, hotelId, offer?.id))

  if (isSplitBooking) {
    return (
      <RoomLabels
        isSplitBooking
        hasRoomLabels={hasRoomLabels}
        splitBookingOffers={splitBookingOffers}
        hotelId={hotelId}
      />
    )
  }

  return (
    <>
      <RoomLabels
        hasRoomLabels={hasRoomLabels}
        offer={offer}
        hotelId={hotelId}
      />
      {isSpecialUnlocked && (
        <Box paddingTop="s100">
          <Text variant="bodyXS" colorPath="content.neutral.secondary">
            {isAppRequiredUnlocked ? (
              <FormattedMessageWrapper
                id="offerAccessFlow.appLocked"
                defaultMessage="Book on Vio app"
              />
            ) : isAuthRequiredUnlocked ? (
              <FormattedMessageWrapper
                id="offerAccessFlow.signInToBookLabel"
                defaultMessage="Sign in to book"
              />
            ) : null}
          </Text>
        </Box>
      )}
    </>
  )
}
